import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15","key":"svg-0"}],["path",{"d":"M9 9a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3l0 -2","key":"svg-1"}],["path",{"d":"M7 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M16 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}]]

const IconTruckLoading = createReactComponent('outline', 'truck-loading', 'TruckLoading', __iconNode);

export default IconTruckLoading;